import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"
import styled from "styled-components"

const StyledFloatInput = styled(FloatInput)`
  ::-webkit-calendar-picker-indicator {
    height: 12px;
    margin-right: -2px;
    width: 11px;
  }
`

const GiftCardDate = ({ arrowColor, control }) => {
  return (
    <Controller
      control={control}
      name="email_send_date"
      render={({ field, fieldState: { error } }) => (
        <StyledFloatInput
          arrowColor={arrowColor}
          error={error}
          label="Send Date"
          mb="0"
          min={new Date().toISOString().slice(0, 10)}
          p="0"
          pattern="(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))"
          type="date"
          {...field}
        />
      )}
    />
  )
}

GiftCardDate.propTypes = {
  arrowColor: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
}

export default GiftCardDate
